// extracted by mini-css-extract-plugin
module.exports = {"header":"B_bY","link":"B_d","content":"B_K","feature":"B_b1","featureName":"B_cJ","featureDescription":"B_cK","featureContent":"B_cL"};